import { render } from "./MiTh.vue?vue&type=template&id=0ccdd765"
import script from "./MiTh.vue?vue&type=script&lang=js"
export * from "./MiTh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTh from 'quasar/src/components/table/QTh.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTh});
